import type { SubState } from './state-types';

/**
 * Resolve SubState values (similar to React's setState).
 *
 * @param value - Either a new value or a function that receives the current value
 * @param currentValue - The current value state to pass to the function
 * @returns The resolved value
 *
 * @example
 * // Direct value
 * resolveSubState({ color: 'red' }, currentPlacement)
 *
 * // Function with previous state
 * resolveSubState(prev => ({ ...prev, color: 'red' }), currentPlacement)
 */
export const resolveSubState = <T>(value: SubState<T>, currentValue: T): T => {
    return typeof value === 'function'
        ? (value as (state: T) => T)(currentValue)
        : value;
};
